import React from 'react';
import { SimpleBlock, Text } from 'ui-builder';

import styles from './FilePreview.module.scss';
import { TextStyle, ViewStyle } from 'react-native';
import { FileDto, formatBytes } from 'nekst-api';

export type FileData = {
  type: string,
  name: string,
}

export function FilePreview(
  props: {
    data?: FileDto,
    style?: ViewStyle
    textStyle?: TextStyle,
    small?: boolean,
    withSize?: boolean
  },
) {
  if (props.data) {

    const classes = [
      styles.preview,
      props.small ? styles.small : '',
    ]

    return (
      <SimpleBlock className={classes.join(' ')} style={props.style}>
        <Text style={props.textStyle}>
          {props.data.name}
          {props.withSize && ` (${formatBytes(props.data.size)})`}
        </Text>
      </SimpleBlock>
    );
  } else {
    return null;
  }
}
